import _ from 'lodash'
import React from 'react'

import { withLegacyRouter } from '../../../../decorators'
import * as Card from '../../../shared/card'
import CrudTable from '../../../shared/CrudTable'
import FriendlyDate from '../../../shared/Date/FriendlyDate'
import ConfirmationDeleteDialog from '../../../shared/DeleteDialog/ConfirmationDeleteDialog'

import ImmunizationForm from './ImmunizationForm'

const mapToFHIR = (patientId, immunizationForm) => {
  const fhir = {
    patient: {
      reference: `Patient/${patientId}`
    },
    date: immunizationForm.date,
    vaccineCode: {
      text: immunizationForm.name,
      coding: [
        {
          code: '143',
          system: 'http://hl7.org/fhir/ValueSet/vaccine-code',
          display: immunizationForm.name
        }
      ]
    },
    id: immunizationForm.id,
    reported: true,
    resourceType: 'Immunization',
    expirationDate: immunizationForm.expirationDate,
    status: 'completed',
    wasNotGiven: false
  }

  if (!immunizationForm.date) {
    delete fhir.date
  }
  if (!immunizationForm.expirationDate) {
    delete fhir.expirationDate
  }
  return fhir
}

const formToFHIR = (immunization, patientId) => {
  const imm = mapToFHIR(patientId, immunization)
  return _(imm).omitBy(_.isUndefined).omitBy(_.isNull).value()
}

const FHIRtoForm = fhir => {
  const formObject = {
    id: fhir.id,
    name: _.get(fhir, 'vaccineCode.text'),
    date: fhir.date,
    expirationDate: fhir.expirationDate,
    isExpired: fhir.isExpired
  }

  return _(formObject).omitBy(_.isUndefined).omitBy(_.isNull).value()
}

// It depends on `FHIRtoForm` resulting `formObject`
// displayFn gets values from `formObject`
const tableDefinition = [
  {
    title: 'Immunization',
    displayFn: v => v.name
  },
  {
    title: 'Date',
    displayFn: v => <FriendlyDate date={_.capitalize(v.date)} />
  },
  {
    title: 'Good Until',
    displayFn: v => <FriendlyDate date={_.capitalize(v.expirationDate)} />
  }
]

class Immunizations extends React.Component {
  constructor (props) {
    super(props)

    const patientId = this.props.params.id

    this.urls = {
      get: () =>
        `/patients/${patientId}/fhir/Immunization/_search?patient=Patient/${patientId}&_count=99999`,
      create: () => `/patients/${patientId}/fhir/Immunization`,
      update: entry => `/patients/${patientId}/fhir/Immunization/${entry.id}`,
      delete: entry => `/patients/${patientId}/fhir/Immunization/${entry.id}`
    }

    this.mapFns = {
      toForm: FHIRtoForm,
      toFhir: entry => formToFHIR(entry, patientId)
    }
  }

  render () {
    return (
      <Card.Card expandable>
        <Card.Header>
          <h2>Immunizations</h2>
        </Card.Header>
        <Card.ExpandableWrapper
          style={{ padding: '0 1rem 1rem' }}
        >
          <CrudTable
            entryType='immunization'
            entrySet={this.props.params.id}
            tableDefinition={tableDefinition}
            urlFns={this.urls}
            mapFns={this.mapFns}
            form={ImmunizationForm}
            deleteDialog={ConfirmationDeleteDialog}
            additionalDeleteDialogProps={{ prompt: 'Really delete?' }}
          />
        </Card.ExpandableWrapper>
      </Card.Card>
    )
  }
}

export default withLegacyRouter(Immunizations)
